export default __webpack_public_path__ + "/assets/fonts/inter-greek-ext-wght-normal.woff2";